var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto",
        "objc_class_prefix": "SharkGameId"
    },
    "messages": [
        {
            "name": "UserBalanceInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "inBill",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "outDiamond",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "bill",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "diamond",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "uint64",
                    "name": "uBean",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "sharkGameCoin",
                    "id": 6
                }
            ]
        },
        {
            "name": "LiveDetailInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "grade",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "onlineTotal",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "roomTitle",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "liveMsg",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "qualityAuth",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "double",
                    "name": "distance",
                    "id": 17
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "distanceStr",
                    "id": 18
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "bigAvatar",
                    "id": 19
                },
                {
                    "rule": "optional",
                    "type": "LiveType",
                    "name": "liveType",
                    "id": 20
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "enterNeedDiamond",
                    "id": 21
                },
                {
                    "rule": "repeated",
                    "type": "LiveLabel",
                    "name": "liveLabels",
                    "id": 22
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "voiceFlag",
                    "id": 23
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ab",
                    "id": 24
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "labels",
                    "id": 25
                },
                {
                    "rule": "optional",
                    "type": "borderType",
                    "name": "borderType",
                    "id": 26
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "borderPicUrl",
                    "id": 27
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "isLandscape",
                    "id": 28
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "gameId",
                    "id": 29
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "roomType",
                    "id": 30
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "roomTypeInfo",
                    "id": 31
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "delayRedPacketFlag",
                    "id": 32
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "chatAndLiveRoomJsonInfo",
                    "id": 33
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "liveCoverUrl",
                    "id": 34
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "fixIndex",
                    "id": 35
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "permanentRoomPic",
                    "id": 36
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatarCoverUrl",
                    "id": 37
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "liveModel",
                    "id": 38
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "enLiveMsg",
                    "id": 39
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "entIcon",
                    "id": 40
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "roomBarrageMsg",
                    "id": 41
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "popularTicketRankNum",
                    "id": 42
                }
            ]
        },
        {
            "name": "LiveLabel",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "labelName",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "labelValue",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ext",
                    "id": 3
                }
            ]
        },
        {
            "name": "LiveInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 3
                }
            ]
        },
        {
            "name": "SharkGameReport",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "winRate",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "wins",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "gameNumber",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "SharkGameId",
                    "name": "gameId",
                    "id": 5
                }
            ]
        },
        {
            "name": "ProfileInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "setting",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "password",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "userToken",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "grade",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "mobilePhone",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "fanTotal",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followTotal",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "UserBalanceInfo",
                    "name": "balance",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "chatroomid",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followType",
                    "id": 17
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "exp",
                    "id": 18
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "currentExp",
                    "id": 19
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "nextExp",
                    "id": 20
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 21
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 22
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "qualityAuth",
                    "id": 23
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 25
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "admin",
                    "id": 26
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "userRealNameAuth",
                    "id": 27
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "acceptAgreement",
                    "id": 28
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "upliveCodeStatus",
                    "id": 29
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "subscribe",
                    "id": 30
                },
                {
                    "rule": "repeated",
                    "type": "Source",
                    "name": "sources",
                    "id": 31
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "dynamicCount",
                    "id": 32
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "dynamicPublishRight",
                    "id": 33
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "liveType",
                    "id": 34
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "enterNeedDiamond",
                    "id": 35
                },
                {
                    "rule": "repeated",
                    "type": "LiveLabel",
                    "name": "liveLabels",
                    "id": 36
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ipForCountry",
                    "id": 37
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "dynamicManageRights",
                    "id": 38
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "newUserDueTime",
                    "id": 39
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "newUser",
                    "id": 40
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "hostStatus",
                    "id": 41
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "guardCount",
                    "id": 42
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 43
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "userTokenValidityTime",
                    "id": 44
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "registrationTime",
                    "id": 45
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "premiumInfo",
                    "id": 46
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "birthday",
                    "id": 47
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "fixedAvartarFramInfo",
                    "id": 48
                },
                {
                    "rule": "repeated",
                    "type": "UserAvatarInfo",
                    "name": "avatars",
                    "id": 49
                },
                {
                    "rule": "optional",
                    "type": "LiveInfo",
                    "name": "liveInfo",
                    "id": 50
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "richerMappingCountryCode",
                    "id": 51
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "isSignUP",
                    "id": 52
                },
                {
                    "rule": "repeated",
                    "type": "string",
                    "name": "hotTopLanguages",
                    "id": 53
                },
                {
                    "rule": "repeated",
                    "type": "OfficialAuthInfo",
                    "name": "officialAuthList",
                    "id": 54
                },
                {
                    "rule": "optional",
                    "type": "SharkGameReport",
                    "name": "sharkGameReport",
                    "id": 55
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "userMemberCollection",
                    "id": 56
                },
                {
                    "rule": "optional",
                    "type": "PermanentRoomInfo",
                    "name": "permanentRoomInfo",
                    "id": 57
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "height",
                    "id": 58
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "industry",
                    "id": 59
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "hauntOften",
                    "id": 60
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "extendSetting",
                    "id": 61
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "multipleSetting",
                    "id": 62
                },
                {
                    "rule": "repeated",
                    "type": "SharkGameReport",
                    "name": "sharkGameReports",
                    "id": 63
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "forbiddenStatus",
                    "id": 64
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "firebaseId",
                    "id": 65
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ipCountryCode",
                    "id": 66
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ipCityCode",
                    "id": 67
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCodeValue",
                    "id": 68
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "userType",
                    "id": 69
                }
            ]
        },
        {
            "name": "Source",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "bindType",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "openId",
                    "id": 2
                }
            ]
        },
        {
            "name": "UserAvatarInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "index",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "identity",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "identityStatus",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "defaultPic",
                    "id": 5
                }
            ]
        },
        {
            "name": "HotTopLanguage",
            "fields": [
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "setFlag",
                    "id": 1
                },
                {
                    "rule": "repeated",
                    "type": "string",
                    "name": "languages",
                    "id": 2
                }
            ]
        },
        {
            "name": "OfficialAuthInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuthId",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 2
                }
            ]
        },
        {
            "name": "OfficialAuthInfoEn",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthIdEn",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContentEn",
                    "id": 2
                }
            ]
        },
        {
            "name": "PermanentRoomInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomNum",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "title",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "pic",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "liveStatus",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 5
                }
            ]
        },
        {
            "name": "RiskCheckParam",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "reCaptchaToken",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "payload",
                    "id": 2
                }
            ]
        },
        {
            "name": "BlackBox",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "tdBox",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "tkid",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "teid",
                    "id": 3
                }
            ]
        },
        {
            "name": "Visitor",
            "fields": [],
            "messages": [
                {
                    "name": "RegisterH5",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "VisitorRegisterH5",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "location",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "countryCode",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "selectLanguage",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "BindType",
                                    "name": "source",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "deviceId",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "tdBx",
                                    "id": 6
                                },
                                {
                                    "rule": "map",
                                    "type": "string",
                                    "keytype": "string",
                                    "name": "shapeHeader",
                                    "id": 7
                                },
                                {
                                    "rule": "optional",
                                    "type": "RiskCheckParam",
                                    "name": "riskCheckParam",
                                    "id": 8
                                },
                                {
                                    "rule": "optional",
                                    "type": "BlackBox",
                                    "name": "blackBox",
                                    "id": 9
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "ProfileInfo",
                                    "name": "profile",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "watchTime",
                                    "id": 2
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "BindType",
            "values": [
                {
                    "name": "DEFAULT_TYPE",
                    "id": 0
                },
                {
                    "name": "MOBILE_PHONE",
                    "id": 1
                },
                {
                    "name": "QQ",
                    "id": 2
                },
                {
                    "name": "WEIXIN",
                    "id": 3
                },
                {
                    "name": "FACEBOOK",
                    "id": 4
                },
                {
                    "name": "SINA_WEIBO",
                    "id": 5
                },
                {
                    "name": "RR",
                    "id": 6
                },
                {
                    "name": "TENCENT_WANBA",
                    "id": 7
                },
                {
                    "name": "KECHENGGEZI",
                    "id": 8
                },
                {
                    "name": "DEVICE",
                    "id": 9
                },
                {
                    "name": "GOOGLE",
                    "id": 15
                },
                {
                    "name": "TWITTER",
                    "id": 16
                },
                {
                    "name": "EMAIL",
                    "id": 17
                },
                {
                    "name": "LINE_BIND",
                    "id": 19
                },
                {
                    "name": "KAKAO",
                    "id": 20
                },
                {
                    "name": "WEIXIN_MINI_PROGRAM",
                    "id": 21
                },
                {
                    "name": "TELEGRAM",
                    "id": 23
                },
                {
                    "name": "APPLE",
                    "id": 24
                },
                {
                    "name": "INSGRAME",
                    "id": 25
                },
                {
                    "name": "HW",
                    "id": 26
                }
            ]
        },
        {
            "name": "PushType",
            "values": [
                {
                    "name": "DEFAULT_PUSHTYPE",
                    "id": 0
                },
                {
                    "name": "BAIDU",
                    "id": 1
                },
                {
                    "name": "IOS",
                    "id": 2
                },
                {
                    "name": "JPUSH",
                    "id": 3
                },
                {
                    "name": "XIAOMI",
                    "id": 4
                },
                {
                    "name": "GETUI",
                    "id": 5
                },
                {
                    "name": "GOOGLE_PUSH",
                    "id": 6
                },
                {
                    "name": "SAMSUNG",
                    "id": 7
                },
                {
                    "name": "MEIZU",
                    "id": 8
                },
                {
                    "name": "HUAWEI",
                    "id": 9
                },
                {
                    "name": "GOOGLE_FCM",
                    "id": 10
                },
                {
                    "name": "VIVO",
                    "id": 11
                },
                {
                    "name": "OPPO",
                    "id": 12
                }
            ]
        },
        {
            "name": "LiveType",
            "values": [
                {
                    "name": "PUBLIC_FREE",
                    "id": 0
                },
                {
                    "name": "PUBLIC_CHARGE",
                    "id": 1
                },
                {
                    "name": "PRIVATE_FREE",
                    "id": 2
                },
                {
                    "name": "PRIVATE_CHARGE",
                    "id": 3
                }
            ]
        },
        {
            "name": "borderType",
            "values": [
                {
                    "name": "PRESERVE",
                    "id": 0
                },
                {
                    "name": "ANCHOR",
                    "id": 1
                },
                {
                    "name": "BIRTHDAY",
                    "id": 2
                },
                {
                    "name": "PKLEVEL",
                    "id": 3
                }
            ]
        },
        {
            "name": "SharkGameId",
            "values": [
                {
                    "name": "DEFAULT_VAL",
                    "id": 0
                },
                {
                    "name": "G0010001",
                    "id": 2
                },
                {
                    "name": "G0010002",
                    "id": 3
                },
                {
                    "name": "G0020003",
                    "id": 4
                },
                {
                    "name": "G0030004",
                    "id": 5
                },
                {
                    "name": "G0010005",
                    "id": 6
                },
                {
                    "name": "G0030007",
                    "id": 7
                },
                {
                    "name": "G0030008",
                    "id": 8
                },
                {
                    "name": "G0030010",
                    "id": 9
                },
                {
                    "name": "G0030011",
                    "id": 10
                },
                {
                    "name": "G0030012",
                    "id": 11
                },
                {
                    "name": "G0030013",
                    "id": 12
                },
                {
                    "name": "G0030014",
                    "id": 13
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/component/visitor/visitor.pb.js